require('./assets/scss/styles.scss');

import Vue from 'vue';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import HomePage from './components/home-page.vue';
import { initPredictiv } from './lib/predictiv';

Vue.use(Toast, {});

initPredictiv();

document.addEventListener('DOMContentLoaded', () => {
  [].forEach.call(document.getElementsByClassName('vue-materials'), el => {
    new Vue({
      components: { HomePage }
    }).$mount(el);
  });
});
